.ol {
    list-style-type: decimal;
    && {
        margin-top: var(--mantine-spacing-xl);
        /* Override any global `ol/ul` padding */
        padding-left: 0 !important;
        padding-inline-start: 0 !important;
        margin-left: 0 !important;
    }
}

.link {
    text-decoration: none;
    color: var(--mantine-color-dark-7);
    cursor: pointer;
    &:hover {
        color: #296d5d;
    }
}

.icon {
    width: 1rem;
    height: 1rem;
    align-self: center;
    margin-left: var(--mantine-spacing-xs);
    flex-shrink: 0;
}

.iconToolArrow {
    width: 1rem;
    height: 1rem;
    align-self: flex-start;
    margin-top: 6px;
    margin-left: var(--mantine-spacing-xs);
    flex-shrink: 0;
}

.iconTool {
    width: var(--mantine-spacing-sm);
    height: var(--mantine-spacing-sm);
    flex-shrink: 0;
    fill: alpha(#296d5d, 0.5);
}

.description {
    color: alpha(var(--mantine-color-dark-5), 0.75);
}

.cardHeader {
    padding-top: var(--mantine-spacing-md);
}

.card {
    --book-icon-size: 1.3rem;

    padding: 1.2rem var(--mantine-spacing-xs);
    /* padding-bottom: var(--mantine-spacing-xl); */
    margin: var(--mantine-spacing-sm) 0 0;
    border-radius: 0;

    @container (min-width: $mantine-breakpoint-xs) {
        padding: 1.2rem var(--mantine-spacing-xl);
        margin: var(--mantine-spacing-xl) 0 var(--mantine-spacing-xs);
        border-radius: 0;
    }
}

.cardTitle {
    font-size: var(--mantine-font-size-md);
    font-weight: 500;
    color: var(--mantine-color-dark-7);
    margin: 0 !important;
    margin-top: 2px !important;

    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-lg);
        margin-top: 0 !important;
    }
}

.indexWrapper {
    margin-left: 3px;
    @container (min-width: $mantine-breakpoint-xs) {
        margin-left: 0;
    }
}

.index {
    font-size: var(--mantine-font-size-xs);
    color: var(--mantine-color-dark-7);

    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-sm);
    }
}

.content {
    font-size: var(--mantine-font-size-sm);
    margin-left: 2px;
    @container (min-width: $mantine-breakpoint-xs) {
        margin-left: 0px;
    }
    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-md);
    }
}

.feedbackContent {
    color: red;
}

.consideredSourcesButton {
    color: alpha(#296d5d, 0.5);

    &:hover {
        background-color: transparent;
        color: #296d5d;
    }
}
